document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', function (e) {
    if (e.target.matches('.pt_tabs a')) {
      e.preventDefault();
      var Data_content = e.target.getAttribute('href');

      var tabs = document.querySelectorAll('.pt_tabs a');
      tabs.forEach(function (tab) {
        tab.classList.remove('active_tab');
      });
      e.target.classList.add('active_tab');

      var tabPanes = document.querySelectorAll('.tabs-contents .w-tab-pane');
      tabPanes.forEach(function (pane) {
        pane.style.display = 'none';
        pane.classList.remove('active_panel');
      });
      
      var activePane = document.querySelector(Data_content);
      if (activePane) {
        activePane.style.display = 'block';
        activePane.classList.add('active_panel');
      }
    }
  });

});